require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-mark-palfreeman.json") })
        }
      }, "path---blog-author-mark-palfreeman");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-mark-palfreeman!./.cache/json/blog-author-mark-palfreeman.json
// module id = 673
// module chunks = 231608221292675